import { TemplateStatus } from '@piccolohealth/pbs-common';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useUpdateTemplateMutation } from '../../graphql/hooks/useUpdateTemplateMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  templateId: string;
  templateName: string;
}

export const TemplateDeleteModal = createModal<Props>((props) => {
  const { templateId, templateName, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useUpdateTemplateMutation();

  const navigate = useNavigate();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        templateId,
        request: {
          status: TemplateStatus.Archived,
        },
      })
      .then(async () => {
        successToast('Template deleted successfully');
        await navigate(`/organizations/${organization.id}/templates`);
      })
      .catch((err) => {
        errorToast(`Error deleting template: ${err.message}`);
      });
  }, [mutation, navigate, organization.id, templateId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this template?'
      confirmation={{ level: 'Level2', confirm: templateName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
